import React from 'react';
import { Box, Tabs, TabList, TabPanels, Tab, TabPanel } from '@chakra-ui/react';
import Security from './account/Security';
import AccountSignIn from './account/SignIn';

export default function AccountSettings() {
    return (
        <Box paddingX={'6'} paddingBottom='10'>
            <Tabs>
                <TabList>
                    <Tab>Sign-in method</Tab>
                    <Tab>Security</Tab>
                    <Tab>Theme</Tab>
                    <Tab>Reminders</Tab>
                </TabList>

                <TabPanels>
                    <TabPanel>
                        <AccountSignIn />
                    </TabPanel>
                    <TabPanel>
                        <Security />
                    </TabPanel>
                    <TabPanel>
                        <p>Theme!</p>
                    </TabPanel>
                    <TabPanel>
                        <p>Reminders!</p>
                    </TabPanel>
                </TabPanels>
            </Tabs>
        </Box>
    )
}